import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivityMetricsV2AgentRollup, ActivityMetricsV2Event, ActivityMetricsV2SubjectRollup } from '../../../../shared/models/activity-metrics-v2.model';

@Component({
  selector: 'app-agent-performance-activity-metrics-audit-overview-widget',
  templateUrl: './agent-performance-activity-metrics-audit-overview-widget.component.html',
  styleUrls: ['./agent-performance-activity-metrics-audit-overview-widget.component.scss']
})
export class AgentPerformanceActivityMetricsAuditOverviewWidgetComponent {
  @Input() timeline: ActivityMetricsV2Event[] = [];
  @Input() subjects: ActivityMetricsV2SubjectRollup[] = [];
  @Input() agents: ActivityMetricsV2AgentRollup[] = [];
  @Input() selectedTimelineEvent: ActivityMetricsV2Event | null = null;
  @Input() selectedSubjectRollup: ActivityMetricsV2SubjectRollup | null = null;
  @Input() collapsedSections: Record<string, boolean> = {};

  @Output() timelineEventSelected = new EventEmitter<ActivityMetricsV2Event>();
  @Output() subjectSelected = new EventEmitter<ActivityMetricsV2SubjectRollup>();
  @Output() sectionToggled = new EventEmitter<string>();

  isSectionCollapsed(sectionKey: string): boolean {
    return !!this.collapsedSections[sectionKey];
  }

  toggleSection(sectionKey: string): void {
    this.sectionToggled.emit(sectionKey);
  }

  selectTimelineEvent(event: ActivityMetricsV2Event): void {
    this.timelineEventSelected.emit(event);
  }

  selectSubject(subject: ActivityMetricsV2SubjectRollup): void {
    this.subjectSelected.emit(subject);
  }

  trackByEvent(index: number, item: ActivityMetricsV2Event): string {
    return item.event_id;
  }
}
